export enum UserType {
  CoreUser = 'core-user',
  Contributor = 'contributor',
  Guest = 'guest',
}
